/** 보이는 영역(iOS 크롬·사파리 주소창 보정). dots-draw 의 orient.ts 에서 회전 없이 가져옴. */
export function viewport(): { w: number; h: number; top: number; left: number } {
  const vv = window.visualViewport;
  if (vv) return { w: Math.round(vv.width), h: Math.round(vv.height), top: Math.round(vv.offsetTop), left: Math.round(vv.offsetLeft) };
  return { w: window.innerWidth, h: window.innerHeight, top: 0, left: 0 };
}
export function watchViewport(cb: () => void): () => void {
  let last = '';
  const check = () => { const v = viewport(); const k = `${v.w}x${v.h}@${v.left},${v.top}`; if (k !== last) { last = k; cb(); } };
  const id = setInterval(check, 250);
  window.addEventListener('resize', check);
  window.visualViewport?.addEventListener('resize', check);
  window.visualViewport?.addEventListener('scroll', check);
  window.addEventListener('scroll', () => window.scrollTo(0, 0));
  check();
  return () => { clearInterval(id); window.removeEventListener('resize', check); window.visualViewport?.removeEventListener('resize', check); window.visualViewport?.removeEventListener('scroll', check); };
}
export function fitRoot(el: HTMLElement): [number, number] {
  const v = viewport();
  el.style.left = `${v.left}px`; el.style.top = `${v.top}px`; el.style.width = `${v.w}px`; el.style.height = `${v.h}px`;
  return [v.w, v.h];
}
